import { useState, useEffect } from 'react';

/**
 * Subscribes to a media query and returns whether it matches.
 * @param query - CSS media query string (e.g. '(max-width: 991px)')
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const media = window.matchMedia(query);
    setMatches(media.matches);
    const listener = (e: MediaQueryListEvent) => setMatches(e.matches);
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, [query]);

  return matches;
}

/** True when viewport is below Bootstrap lg (992px). Use for mobile layout. */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 991px)');
}
